// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EBTv","placeholdersHeader":"styles_placeholdersHeader__1eouJ","editorStyle":"styles_editorStyle__3CPEq","placeholdersBox":"styles_placeholdersBox__3frxx"};